export const setFilterData = data => ({
  type: 'SET_ORDER_FILTERS',
  data,
});

export const setFilterFlag = data => ({
  type: 'SET_ORDER_FILTER_FLAG',
  data,
});
